import React, { useState } from 'react'
import { Button, DatePicker, Input, Space } from 'antd'
import TablePage from '../../../../../components/pages/TablePage'
import moment from 'moment'

const dateFormat = 'DD-MMM-YYYY'

const DepartureFilters = ({ onSubmitSearch }) => {
    const [filters, setFilters] = useState(() => ({
        flight_date_str: moment().format(dateFormat),
        flight_number: ''
    }))

    const applyFilter = () => {
        const payload = {}

        if (filters.flight_date_str) {
            payload.flight_date_str = filters.flight_date_str
        }

        if (filters.flight_number) {
            payload.flight_number = filters.flight_number
        }

        onSubmitSearch(payload)
    }

    return (
        <Space wrap style={{ marginBottom: 12 }}>
            <DatePicker
                allowClear
                format={dateFormat}
                placeholder="Filter Flight Date"
                value={filters.flight_date_str ? moment(filters.flight_date_str, dateFormat) : null}
                onChange={(value) => {
                    const dateValue = value ? value.format(dateFormat) : ''
                    setFilters(prev => ({ ...prev, flight_date_str: dateValue }))

                    if (!dateValue && !filters.flight_number) {
                        onSubmitSearch({})
                    }
                }}
            />
            <Input
                allowClear
                placeholder="Filter Flight Number"
                style={{ width: 200 }}
                value={filters.flight_number}
                onChange={(event) => {
                    const uppercaseValue = (event?.target?.value || '').toUpperCase()
                    setFilters(prev => ({ ...prev, flight_number: uppercaseValue }))

                    if (!uppercaseValue && !filters.flight_date_str) {
                        onSubmitSearch({})
                    }
                }}
            />
            <Button type="primary" onClick={applyFilter}>
                Apply Filter
            </Button>
        </Space>
    )
}

export default () => {
    const defaultQuery = { flight_date_str: moment().format('DD-MMM-YYYY') }
    const columns = [
        {
            selector: (row) => row?.airline_id?.name,
            name: "Airline",
            id: 'airline_id'
        },
        {
            selector: (row) => row?.flight_number,
            name: "Flight Number",
            id: 'flight_number'
        },
        {
            selector: (row) => row?.flight_date_str,
            name: "Flight Date",
            id: 'flight_date_str'
        },
        {
            selector: (row) => row?.acreg,
            name: "ACReg",
            id: 'acreg'
        },
        {
            selector: (row) => row?.origin?.code,
            name: "Origin",
            id: 'origin'
        },
        {
            selector: (row) => row?.dest?.code,
            name: "Dest",
            id: 'dest'
        },
        {
            selector: (row) => row?.localSta,
            name: "STA",
            id: 'localSta'
        },
        {
            selector: (row) => row?.localEta,
            name: "ETA",
            id: 'localEta'
        },
        {
            selector: (row) => row?.localAta,
            name: "ATA",
            id: 'localAta'
        },
        {
            selector: (row) => row?.status,
            name: "Status",
            id: 'status'
        },
        {
            selector: (row) => (row?.createdAt && moment(row.createdAt).format('DD-MMM-YYYY HH:mm')) || '-',
            name: "CreatedAt",
            id: 'created_at'
        },
    ]
    return (
        <TablePage
            title={"Departure Flight Record"}
            url="api/v1/flight_record/departure"
            actionPosition={'first'}
            columns={columns}
            createPath="/fr/create"
            HeaderComponent={DepartureFilters}
            defaultQuery={defaultQuery}
        />
    )
}
